<template>
  <div class="total">
    <div class="total__left">
      <div class="total__title">
        <div class="total__title__img">
          <img :src="server_img" alt="服务器图标" />
        </div>
        <div class="total__title__name">{{data.name}}</div>
      </div>
      <div class="total__sub-title">
        <div class="total__sub-title__status" :class="statusClass">{{data.status}}</div>
        <div
          class="total__sub-title__status-machine"
        >{{`已启动 ${data.instanceSize} 个实例`}}</div>
      </div>
      <div class="total__error">
        <div class="total__error__title">
          <div class="total__error__title__img">
            <img :src="error_img" alt="异常图标" />
          </div>
          <div class="total__error__title__text">输出信息</div>
        </div>

        <ul class="total__error__list">
          <li v-for="(log,index) in data.logList" class="total__error__list__item" :key="index">
            <div class="total__error__list__item__level">{{log.level}}</div>
            <div class="total__error__list__item__content">{{log.content}}</div>
            <div class="total__error__list__item__time">{{log.time}}</div>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="total__right"> -->
    <!-- <ServerStatusPie /> -->
    <!-- </div> -->
  </div>
</template>

<script>
// import ServerStatusPie from "@/components/home/ServerStatusPie";
import server_img from "@/assets/images/server.png";
import error_img from "@/assets/images/error.png";

export default {
  name: "Total",
  data() {
    return {
      server_img,
      error_img
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          name: "",
          status: "",
          instanceSize: 0,
          time: "",
          logList: [
            {
              level: "",
              content: "",
              time: ""
            }
          ]
        };
      }
    }
  },
  computed: {
    statusClass: function() {
      let name = "";
      switch (this.data.status) {
        case "等待中":
          name = "wait";
          break;
        case "回测中":
          name = "progress";
          break;
        case "已完成":
          name = "finish";
          break;
      }
      return name;
    }
  },
  components: {
    // ServerStatusPie
  }
};
</script>

<style lang="less" scoped>
.total {
  display: flex;
  height: 12.5rem;
  background-color: #262934;
  box-shadow: -0.62rem 0.63rem 1.25rem 0rem rgba(30, 30, 30, 0.05);
  border-radius: 0.31rem;
  padding: 1.88rem 1.88rem 1.19rem 1.88rem;
  box-sizing: border-box;

  @media screen and (max-width: 1440px) {
    padding: 1.13rem 1.13rem 0.88rem 1.13rem;
  }

  &__left {
    width: 100%;
  }

  &__title {
    font-size: 1.25rem;
    color: #cad0d5;
    display: flex;
    align-items: center;

    &__img {
      width: 1.4rem;
      height: 1.4rem;
      margin-right: 0.63rem;

      & > img {
        width: 100%;
        height: 100%;
      }
    }

    &__name {
      flex: 1;
      line-height: 1.25rem;
    }
  }

  &__sub-title {
    display: flex;
    font-size: 0.88rem;
    line-height: 1.25rem;
    margin-top: 0.69rem;

    &__status {
      width: 3rem;
      color: #9eabbe;
      margin-right: 1.2rem;
      word-break: keep-all;

      &.progress {
        color: #01b377;
      }
      &.finish {
        color: #4e71e6;
      }
      &.wait {
        color: #9eabbe;
      }
    }
    &__status-machine {
      flex: 1;
      font-size: 0.88rem;
      color: #cad0d5;
      word-break: keep-all;
    }
  }

  &__error {
    width: 80%;
    margin-top: 1.25rem;

    &__title {
      font-size: 0.88rem;
      line-height: 0.88rem;
      color: #ff5400;
      margin-bottom: 0.63rem;
      display: flex;

      &__img {
        width: 0.88rem;
        height: 0.88rem;
        margin-right: 0.63rem;

        & > img {
          width: 100%;
          height: 100%;
        }
      }
    }

    &__list {
      list-style-type: none;
      color: #9eabbe;
      font-size: 0.75rem;
      line-height: 0.75rem;

      &__item {
        margin-bottom: 0.53rem;
        display: flex;

        &__level {
          width: 5rem;
        }

        &__content {
          flex: 1;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &__time {
          width: 7rem;
        }
      }
    }
  }
}
</style>